import { h } from 'preact';

const SIZE_REGEX = /_\d+x\./;

const getSizedImageUrl = (src, size) => {
  if (size === null) return src;
  if (!src) return false;
  const match = src.match(/\.(jpg|jpeg|gif|png|bmp|bitmap|tiff|tif|webp)(\?v=\d+)?$/i);
  if (!match) return null;
  const prefix = src.split(match[0])[0];
  const suffix = match[0];

  // Handle edge case where image is hosted on Shopify CDN and resizing has to be done differently
  if (src.includes('cdn.shopify.com')) {
    // Check if URL already has size parameters and replace them
    if (src.includes('_') && src.match(SIZE_REGEX)) {
      // Replace existing size with new size
      return src.replace(SIZE_REGEX, `_${size}x.`);
    }
    // Otherwise add size parameter using query parameter format
    return `${prefix}${suffix}?width=${size}&height=${size}&crop=center`;
  }
  return `${prefix}_${size}x${suffix}`.replace(/http(s)?:/, '');
};

const Image = ({
  alt,
  src,
  srcWidths = {},
  height,
  width,
  classes = '',
  loading = 'lazy',
  isCustomMetafieldImage = false,
  pngBgColor = window.TMW?.settings?.productPngBgColor,
}) => {
  const bps = { sm: 640, md: 768, lg: 1024, xl: 1280, '2xl': 1536 };
  const widths = { ...srcWidths };

  // Remove undefined breakpoints
  Object.keys(bps).forEach((key) => {
    if (widths[key] === undefined) {
      delete bps[key];
    }
  });

  // Reduce to values arrays
  const srcWidthsReduced = Object.values(widths).filter(Boolean);
  const sizeWidthsReduced = Object.values(bps).filter(Boolean);

  // Convert to srcSet and sizes values
  const srcsetFormatted = isCustomMetafieldImage
    ? srcWidthsReduced.map((w) => {
        // For custom metafield images that already have size, replace it
        if (src.match(SIZE_REGEX)) {
          return `${src.replace(SIZE_REGEX, `_${w}x.`)} ${w}w`;
        }
        return `${src} ${w}w`;
      }).join(',')
    : srcWidthsReduced.map((w) => `${getSizedImageUrl(src, w)} ${w}w`).join(',');

  const sizesFormatted = sizeWidthsReduced.map((w, i) => `(max-width: ${w}px) ${srcWidthsReduced[i]}px`).join(', ');

  const altText = alt || '';
  const altParts = altText.split(' | ');
  const altPart = altParts[0];

  const isPng = /\.png(\?v=\d+)?$/i.test(src);

  return (
    <img
      className={`image ${classes}`}
      style={isPng && pngBgColor ? { backgroundColor: pngBgColor } : undefined}
      srcSet={srcsetFormatted}
      sizes={sizesFormatted}
      src={src}
      alt={altPart || ''}
      height={height}
      width={width}
      loading={loading}
    />
  );
};

export default Image;
